import React, { useState } from "react";
import styled from "styled-components";
import RadioGroup from "sushiweb/RadioGroup";
import Input from "sushiweb/InputTypes/Input";
import { Tooltip } from "@material-ui/core";
import Modal from "sushiweb/Modal";
import {
  BorderedBox,
  FlexContainer,
  Pill,
  FieldsSection,
  Divider,
} from "../../constants/assets/containers";
import QcDriverDocumentDetailFields from "../../constants/QcDetails/QcDocumentDetailFields.json";
import {
  capitalizeFirstLetter,
  getPath,
  isMobile,
  isValNull,
} from "../../utils";
import Toast from "sushiweb/Toast";
import variables from "../../constants/assets/variables";
import CheckBoxDropDown from "../Common/CheckBoxDropDown";
import PaginatedReactDropdown from "../Common/PaginatedReactDropdown";
import AddEdit from "sushiweb/Icons/all/AddEdit";
import CheckCircleFill from "sushiweb/Icons/all/CheckCircleFill";
import CrossCircleFill from "sushiweb/Icons/all/CrossCircleFill";
import QcDetails, { DocImg } from "../../views/QcDetails";
import { getState, getStateList } from "../../store/actions/State";
import DriverDocumentModal from "../Common/DriverDocumentModal";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { setQcDetails, updateQcField } from "../../store/actions/QcDetails";
import moment from "moment";
import InfiniteScrollDropdown from "../Common/InfiniteScrollDropdown";
import { DocImgContainer } from "./QcDriverBasicDetailsEdit";

const QcDriverDocumentDetailsEdit = ({
  details = {},
  onboardingFlow,
  initialState = {},
  editableField,
  rejectionReasons,
  docTypes,
  verifiedOptions,
  setEditableField,
  showSingleFieldEditOptions,
  setShowSingleFieldEditOptions,
  setInitialState,
  updateQcField,
  setQcDetails,
  currentActiveFeId,
  handleVerifiedChange,
  handleRejectionReasonChange,
  handleDocTypeChange,
  qcApproved,
  allMenuActions,
  permission,
  nextPageState,
  getStateList,
  getState,
}) => {
  const [modalContent, setModalContent] = useState("");
  const [showModal, setShowModal] = useState("");
  const [activeImageItemKey, setActiveImageItemKey] = useState({});
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");

  const Slide = ({ docData }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleItemClick = () => {
      setIsModalOpen(true);
    };

    const handleModalClose = () => {
      setIsModalOpen(false);
    };

    const heading = "Document submitted";
    const doc_url = docData.src;

    return (
      <div>
        <FlexContainer>
          <DocImg
            src={doc_url}
            cursor="pointer"
            alt="Document Image"
            onClick={handleItemClick}
          />

          <Modal
            className={"full-height-modal"}
            visible={isModalOpen}
            onClose={handleModalClose}
            showCloseIcon={true}
            slideOnMobile
            isCentered
            padding="2rem"
            preventFocus
            title={heading}
          >
            <img
              src={doc_url}
              alt="Document Image"
              style={{ width: 500, height: 500 }}
            />
          </Modal>
        </FlexContainer>
      </div>
    );
  };

  const sortDocuments = (obj) => {
    var accumulator = Object.keys(obj)
      .sort()
      .reduce((accumulator, key) => {
        accumulator[key] = obj[key];

        return accumulator;
      }, {});
    return accumulator;
  };

  const handleClose = () => {
    setShowModal(false);
  };

  const closeToast = () => {
    setToast(false);
  };

  const handleDocClick = (file, item) => {
    setModalContent(file);
    setShowModal(true);
    setActiveImageItemKey(item);
  };

  const handleEditSingleField = (item) => {
    setEditableField(item.key);
    setShowSingleFieldEditOptions(item.key);
  };

  const getEvRadio = (val, label) => {
    if (label == "Ownership Type") {
      let resp = [
        {
          label: "Owned",
          value: "Owned",
          disabled: true,
        },
        {
          label: "Rented",
          value: "Rented",
          disabled: true,
        },
      ];
      return resp;
    } else {
      let resp = [
        {
          label: "With number plate",
          value: true,
          disabled: true,
        },
        {
          label: "Without number plate",
          value: false,
          disabled: true,
        },
      ];
      return resp;
    }
  };

  const handleCrossClick = (item) => {
    setEditableField("");
    setShowSingleFieldEditOptions("");
    const values = JSON.parse(JSON.stringify(initialState));
    const currVal = getPath(details, item.valuePath, "");
    let secondaryVal = "";
    if (item.secondaryKey) {
      secondaryVal = getPath(details, item.valuePath, "")[[item.secondaryKey]];
    }
    if (values["document_details"][item.key]) {
      values["document_details"][item.key][item.valueKey] =
        currVal[item.valueKey];
      if (item.key == "pan_card_doc") {
        values["document_details"][item.key]["dob"] = currVal["dob"];
        values["document_details"][item.key]["name"] = currVal["name"];
        values["document_details"][item.key]["fathers_name"] =
          currVal["fathers_name"];
        values["document_details"][item.key]["gender"] = currVal["gender"];
      }
      if (item.key == "bank_doc") {
        values["document_details"][item.key]["bank_name"] =
          currVal["bank_name"];
        values["document_details"][item.key]["ifsc_code"] =
          currVal["ifsc_code"];
        values["document_details"][item.key]["beneficiary_name"] =
          currVal["beneficiary_name"];
      }
    }
    if (secondaryVal) {
      values["document_details"][item.key][item.secondaryKey] = secondaryVal;
    }
    setInitialState(values);
  };

  const getSecondaryField = (item) => {
    if (item.secondaryKey === "zip_code") {
      return (
        <Input
          id="sushi-input"
          data-testId={"Qc-zip_code_" + item.key}
          disabled={editableField !== item.key}
          label={item.secondaryKeyLabel}
          fullWidth
          onChange={(e) =>
            handleChange(item, e, item.secondaryKey, item.secondaryKeyInt)
          }
          value={
            getPath(initialState, item.valuePath, "")[item.secondaryKey] || ""
          }
        />
      );
    }
  };

  const handleSaveSingleField = (item) => {
    if (!getPath(details, item.valuePath, "")) {
      return;
    }
    let secondaryValDiff = false;
    let shouldUpdateDOb = false;
    let shouldUpdatePanName = false;
    let shouldUpdateGender = false;
    let shouldUpdateFathersName = false;
    let bankDiff = false;

    if (item.key == "pan_card_doc") {
      const currDobDiff =
        getPath(details, item.valuePath, "")["dob"] !==
        getPath(initialState, item.valuePath, "")["dob"];
      if (currDobDiff) {
        shouldUpdateDOb = true;
      }
      shouldUpdatePanName =
        getPath(details, item.valuePath, "")["name"] !==
        getPath(initialState, item.valuePath, "")["name"];

      shouldUpdateGender =
        getPath(details, item.valuePath, "")["gender"] !==
        getPath(initialState, item.valuePath, "")["gender"];

      shouldUpdateFathersName =
        getPath(details, item.valuePath, "")["fathers_name"] !==
        getPath(initialState, item.valuePath, "")["fathers_name"];
    }

    if (item.key == "bank_doc") {
      bankDiff =
        getPath(details, item.valuePath, "")["ifsc_code"] !==
          getPath(initialState, item.valuePath, "")["ifsc_code"] ||
        getPath(details, item.valuePath, "")["bank_name"] !==
          getPath(initialState, item.valuePath, "")["bank_name"] ||
        getPath(details, item.valuePath, "")["beneficiary_name"] !==
          getPath(initialState, item.valuePath, "")["beneficiary_name"] ||
        getPath(details, item.valuePath, "")["value"] !==
          getPath(initialState, item.valuePath, "")["value"];

      if (
        getPath(details, item.valuePath, "")["ifsc_code"] !==
          getPath(initialState, item.valuePath, "")["ifsc_code"] &&
        !validateIFSC(getPath(initialState, item.valuePath, "")["ifsc_code"])
      ) {
        setToast(true);
        setToastMessage("Please enter valid IFSC code!");
        return;
      }
    }

    let shouldUpdate = false;
    const currValDiff =
      getPath(details, item.valuePath, "")[item.valueKey] !==
      getPath(initialState, item.valuePath, "")[item.valueKey];
    if (currValDiff || shouldUpdateFathersName || shouldUpdateDOb) {
      if (
        item.key == "pan_card_doc" &&
        !validePan(getPath(initialState, item.valuePath, "")[item.valueKey])
      ) {
        setToast(true);
        setToastMessage("Please enter valid PAN no!");
        return;
      }

      if (
        item.key == "pan_card_doc" &&
        !isValidDateOfBirth(getPath(initialState, item.valuePath, "")["dob"])
      ) {
        setToast(true);
        setToastMessage(
          "Please enter valid DOB(age should be greater than 18 years)"
        );
        return;
      }

      if (
        item.key == "pan_card_doc" &&
        !isValidFathersName(
          getPath(initialState, item.valuePath, "")["fathers_name"]
        )
      ) {
        setToast(true);
        setToastMessage("Please enter valid father's name!");
        return;
      }

      if (
        item.key == "license_card_doc" &&
        !validateLicenseNo(
          getPath(initialState, item.valuePath, "")[item.valueKey]
        )
      ) {
        setToast(true);
        setToastMessage("Please enter valid LicenseNo no!");
        return;
      }

      shouldUpdate = true;
    }

    if (item.secondaryKey) {
      secondaryValDiff = true;
      if (secondaryValDiff) {
        shouldUpdate = true;
      }
    }

    if (item.secondaryKey) {
      if (
        isValNull(getPath(initialState, item.valuePath, "")[item.secondaryKey])
      )
        return;
      if (
        item.secondaryKey == "zip_code" &&
        !validePinCode(
          getPath(initialState, item.valuePath, "")[[item.secondaryKey]]
        )
      ) {
        setToast(true);
        setToastMessage("Please enter valid pin-code!");
        return;
      }
    }

    if (
      item.additionalAddressField &&
      (isValNull(getPath(initialState, item.valuePath, "")["city"]) ||
        isValNull(getPath(initialState, item.valuePath, "")["state_id"]))
    ) {
      return;
    }

    if (isValNull(getPath(initialState, item.valuePath, "")[item.valueKey])) {
      return;
    }

    if (
      shouldUpdate &&
      (shouldUpdateDOb ||
        shouldUpdatePanName ||
        shouldUpdateFathersName ||
        shouldUpdateGender)
    ) {
      const payload = {
        document_details: {
          [item.key]: {
            id: getPath(initialState, item.valuePath, "")["id"],
            dob: getPath(initialState, item.valuePath, "")["dob"],
            name: getPath(initialState, item.valuePath, "")["name"],
            fathers_name: getPath(initialState, item.valuePath, "")[
              "fathers_name"
            ],
            gender: getPath(initialState, item.valuePath, "")["gender"],
            value: getPath(initialState, item.valuePath, "")[item.valueKey],
          },
        },
      };
      updateQcField(currentActiveFeId, payload).then((res) => {
        if (res) {
          const newDetails = JSON.parse(JSON.stringify(details));
          newDetails["document_details"][item.key]["dob"] =
            payload["document_details"][item.key]["dob"];
          newDetails["document_details"][item.key]["name"] =
            payload["document_details"][item.key]["name"];
          newDetails["document_details"][item.key]["fathers_name"] =
            payload["document_details"][item.key]["fathers_name"];
          newDetails["document_details"][item.key]["gender"] =
            payload["document_details"][item.key]["gender"];
          newDetails["document_details"][item.key][item.valueKey] =
            payload["document_details"][item.key][item.valueKey];
          setQcDetails(newDetails);
          setEditableField("");
          setShowSingleFieldEditOptions("");
        }
      });
    } else if (shouldUpdate || bankDiff) {
      const payload = {
        document_details: {
          [item.key]: {
            id: getPath(initialState, item.valuePath, "")["id"],
            value: getPath(initialState, item.valuePath, "")[item.valueKey],
          },
        },
      };

      if (bankDiff) {
        payload.document_details[item.key]["value"] = getPath(
          initialState,
          item.valuePath,
          ""
        )["value"];
        payload.document_details[item.key]["ifsc_code"] = getPath(
          initialState,
          item.valuePath,
          ""
        )["ifsc_code"];
        payload.document_details[item.key]["bank_name"] = getPath(
          initialState,
          item.valuePath,
          ""
        )["bank_name"];
        payload.document_details[item.key]["beneficiary_name"] = getPath(
          initialState,
          item.valuePath,
          ""
        )["beneficiary_name"];
        payload.document_details[item.key]["value"] = getPath(
          initialState,
          item.valuePath,
          ""
        )["value"];
      }

      if (secondaryValDiff) {
        payload.document_details[item.key][item.secondaryKey] =
          item.secondaryKeyInt
            ? Number(
                getPath(initialState, item.valuePath, "")[item.secondaryKey]
              )
            : getPath(initialState, item.valuePath, "")[item.secondaryKey];
      }
      if (item.additionalAddressField) {
        payload.document_details[item.key]["city"] = getPath(
          initialState,
          item.valuePath,
          ""
        )["city"];
        payload.document_details[item.key]["state_id"] = getPath(
          initialState,
          item.valuePath,
          ""
        )["state_id"];
        payload.document_details[item.key]["state"] = getPath(
          initialState,
          item.valuePath,
          ""
        )["state"];
      }
      updateQcField(currentActiveFeId, payload).then((res) => {
        if (res) {
          const newDetails = JSON.parse(JSON.stringify(details));
          newDetails["document_details"][item.key][item.valueKey] =
            payload["document_details"][item.key][item.valueKey];
          if (secondaryValDiff) {
            newDetails["document_details"][item.key][item.secondaryKey] =
              payload["document_details"][item.key][item.secondaryKey];
          }
          if (item.additionalAddressField) {
            newDetails["document_details"][item.key]["city"] = getPath(
              payload,
              item.valuePath,
              ""
            )["city"];
            newDetails["document_details"][item.key]["state_id"] = getPath(
              payload,
              item.valuePath,
              ""
            )["state_id"];
            newDetails["document_details"][item.key]["state"] = getPath(
              payload,
              item.valuePath,
              ""
            )["state"];
          }
          setQcDetails(newDetails);
          setEditableField("");
          setShowSingleFieldEditOptions("");
        }
      });
    } else if (shouldUpdateDOb || shouldUpdatePanName || shouldUpdateGender) {
      const payload = {
        document_details: {
          [item.key]: {
            id: getPath(initialState, item.valuePath, "")["id"],
            dob: getPath(initialState, item.valuePath, "")["dob"],
            name: getPath(initialState, item.valuePath, "")["name"],
            gender: getPath(initialState, item.valuePath, "")["gender"],
          },
        },
      };
      updateQcField(currentActiveFeId, payload).then((res) => {
        if (res) {
          const newDetails = JSON.parse(JSON.stringify(details));
          console.log("newDetails", newDetails);
          newDetails["document_details"][item.key]["dob"] =
            payload["document_details"][item.key]["dob"];
          newDetails["document_details"][item.key]["name"] =
            payload["document_details"][item.key]["name"];
          newDetails["document_details"][item.key]["gender"] =
            payload["document_details"][item.key]["gender"];
          setQcDetails(newDetails);
          setEditableField("");
          setShowSingleFieldEditOptions("");
        }
      });
    }
  };

  const handleChange = (item, val, keyToUse = "", isInteger = false) => {
    const values = JSON.parse(JSON.stringify(initialState));
    if (values["document_details"][item.key]) {
      values["document_details"][item.key][keyToUse || item.valueKey] =
        isInteger && val ? Number(val) : val;
    }
    setInitialState(values);
  };

  const validePinCode = (pinCode) => {
    let number = parseInt(pinCode, 10);
    return /^[0-9]{6}$/.test(number);
  };

  const validePan = (pan) => {
    var regpan = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
    return regpan.test(pan);
  };

  const isValidDateOfBirth = (dob) => {
    if (!dob) return false;
    return moment().diff(moment(dob), "years") >= 18; // Check if DOB is 18 years or older
  };

  const isValidFathersName = (fathersName) => {
    if (!fathersName) return false;
    var regName = /^[a-zA-Z. ]+$/;
    return regName.test(fathersName);
  };

  const validateIFSC = (ifscCode) => {
    var regIFSC = /^[A-Z]{4}[0-9][A-Z0-9]{6}$/;
    return regIFSC.test(ifscCode);
  };

  const validateLicenseNo = (licenseNo) => {
    var regLicense = /^[A-Za-z0-9]+$/;
    return regLicense.test(licenseNo);
  };

  const handleStateChange = (key, val, extraParams, stateObj) => {
    const stateName = getPath(stateObj, "name", "");
    const values = JSON.parse(JSON.stringify(initialState));
    if (values["document_details"]["address_doc"]) {
      values["document_details"]["address_doc"]["state_id"] = Number(val);
      values["document_details"]["address_doc"]["state"] = stateName;
    }
    setInitialState(values);
  };

  const handlePermanentAddressChangeChange = (
    key,
    val,
    extraParams,
    stateObj
  ) => {
    const stateName = getPath(stateObj, "name", "");
    const values = JSON.parse(JSON.stringify(initialState));
    if (values["document_details"]["address_doc"]) {
      values["document_details"]["address_doc"]["state_id"] = Number(val);
      values["document_details"]["address_doc"]["state"] = stateName;
    }
    setInitialState(values);
  };

  const handleChangeDate = (item, val, keyToUse) => {
    const values = JSON.parse(JSON.stringify(initialState));
    let value = moment.utc(val.toLocaleString()).format("YYYY-MM-DD");
    if (values["document_details"][item.key]) {
      values["document_details"][item.key][keyToUse] = value;
    }
    setInitialState(values);
  };

  const isNsdlVerified = (field) => {
    if (["bank_doc"].includes(field.key)) {
      return getPath(details, field.valuePath, "")["third_party_verified"];
    }
    return false;
  };

  const getRequiredFlag = (field) => {
    return getPath(details, field.valuePath, "")["required"];
  };

  // function specific for PAN CARD
  const handleGenderChange = (keyToUse, val) => {
    const values = JSON.parse(JSON.stringify(initialState));
    console.log(val);
    if (values["document_details"]["pan_card_doc"]) {
      values["document_details"]["pan_card_doc"][keyToUse] = val;
    }
    setInitialState(values);
  };

  const getFieldOptions = (item) => {
    if (item === "gender") {
      return ["M", "F", "O"];
    }
  };

  const getField = (item) => {
    switch (item.type) {
      case "text":
        return (
          <Input
            id="sushi-input"
            data-testId={"Qc" + item.key}
            disabled={editableField !== item.key || isNsdlVerified(item)}
            label={item.label}
            fullWidth
            onChange={(e) => handleChange(item, e)}
            value={getPath(initialState, item.valuePath, "")[item.valueKey]}
          />
        );
      default:
        return "";
    }
  };

  const getDropDownForType = (item) => {
    return (
      <CheckBoxDropDown
        options={getDocTypes(item.key)[0]}
        value={
          getPath(
            initialState,
            QcDriverDocumentDetailFields[item.key].valuePath,
            ""
          ).doc_type
        }
        handleChange={handleDocTypeChange}
        placeholder={
          QcDriverDocumentDetailFields[item.key].placeHolderForDocType
        }
        keyToChange={item}
        extraParams={[
          QcDriverDocumentDetailFields[item.key],
          "document_details",
        ]}
        showCross={true}
        labelWidth="30%"
        marginTop="25px"
        id={`driverQcDocumentDetailsDropdown${item}`}
        disabled={
          qcApproved ||
          getPath(initialState, `document_details.${item}.verified`, false)
        }
      />
    );
  };

  const getAdditionalFields = (item) => {
    switch (item.key) {
      case "address_doc":
        return (
          <>
            <Input
              id="sushi-input"
              data-testid={"Qc-city_" + item.key}
              disabled={editableField !== item.key}
              label="City/District"
              fullWidth
              onChange={(e) => handleChange(item, e, "city")}
              value={getPath(initialState, item.valuePath, "")["city"] || ""}
            />
            <InfiniteScrollDropdown
              id="qcRiderStateDropdown"
              priorityFlag
              getActiveList={getStateList}
              nextPage={nextPageState}
              resKey="states"
              modalState="Edit"
              keyName="state_id"
              labelKey="name"
              getDataLabelKey="state.name"
              keyTypeToSet="id"
              disabled={editableField !== item.key}
              label="State"
              handleChange={
                item.key === "address_doc"
                  ? handlePermanentAddressChangeChange
                  : handleStateChange
              }
              remoteSearchApplicable
              activeElement={{
                state_id: getPath(initialState, item.valuePath, "")["state_id"],
              }}
              getActiveItemById={getState}
              appliedFilters={{}}
              notShowCross={true}
              remoteSearchKey="startswith"
            />
          </>
        );
      case "pan_card_doc":
        return (
          <div>
            {onboardingFlow == "STANDARD" ? (
              <>
                <PaginatedReactDropdown
                  id={`driverQcBasicDetailsDropdown${item.key}`}
                  placeholder={"Gender"}
                  options={getFieldOptions("gender")}
                  disabled={editableField !== item.key}
                  value={getPath(initialState, item.valuePath, "")["gender"]}
                  handleChange={handleGenderChange}
                  modalState="Edit"
                  className="inbox-dropdown"
                  keyToChange="gender"
                />
                <FlexContainer justify="space-between">
                  <Input
                    id="sushi-input"
                    disabled={editableField !== item.key}
                    label={"Name on PAN card"}
                    fullWidth
                    onChange={(e) => handleChange(item, e, "name")}
                    value={getPath(initialState, item.valuePath, "")["name"]}
                    type="text"
                  />
                </FlexContainer>
              </>
            ) : (
              <>
                {" "}
                <Input
                  id="sushi-input"
                  className="calender-input"
                  disabled={editableField !== item.key}
                  label={"Name on PAN card"}
                  fullWidth
                  onChange={(e) => handleChange(item, e, "name")}
                  value={getPath(initialState, item.valuePath, "")["name"]}
                  type="text"
                />
              </>
            )}{" "}
            <Input
              id="sushi-input"
              disabled={editableField !== item.key}
              label={"Father's name"}
              fullWidth
              onChange={(e) => handleChange(item, e, "fathers_name")}
              value={getPath(initialState, item.valuePath, "")["fathers_name"]}
              type="text"
            />
            <Input
              id="sushi-input"
              className="calender-input"
              data-testId={"Qc-aadhar"}
              disabled={editableField !== item.key}
              label={"DOB"}
              fullWidth
              onChange={(e) => handleChangeDate(item, e, "dob")}
              value={moment(
                getPath(initialState, item.valuePath, "")["dob"]
              ).format("YYYY-MM-DD")}
              type="date"
            />
          </div>
        );
      case "bank_doc":
        let label = "Pan name";
        let value = getPath(
          details,
          QcDriverDocumentDetailFields["pan_card_doc"].valuePath,
          ""
        )["name"];

        if (onboardingFlow == "FASTRACK") {
          label = "Aadhar name";
          value = getPath(
            details,
            QcDriverDocumentDetailFields["aadhar_card_doc"].valuePath,
            ""
          )["name"];
        }
        return (
          <form>
            <Input
              data-testId={"Qc-associated-field-" + item.key}
              id="sushi-input"
              disabled={editableField !== item.key}
              label={"Beneficiary Name"}
              fullWidth
              onChange={(e) => handleChange(item, e, "beneficiary_name")}
              value={
                getPath(initialState, item.valuePath, "")["beneficiary_name"]
              }
            />
            <Input
              data-testId={"Qc-associated-field-" + item.key}
              id="sushi-input"
              disabled={editableField !== item.key}
              label={"Bank Name"}
              fullWidth
              onChange={(e) => handleChange(item, e, "bank_name")}
              value={getPath(initialState, item.valuePath, "")["bank_name"]}
            />
            <FlexContainer justify="space-between">
              <Input
                id="sushi-input"
                data-testId="modalInputVal"
                disabled={editableField !== item.key}
                label="Bank account number"
                onChange={(e) => handleChange(item, e, "value")}
                value={getPath(initialState, item.valuePath, "")["value"]}
              />
              <Input
                data-testId={"Qc-associated-field-" + item.key}
                id="sushi-input"
                disabled={editableField !== item.key}
                label="IFSC code"
                onChange={(e) => handleChange(item, e, "ifsc_code")}
                value={getPath(initialState, item.valuePath, "")["ifsc_code"]}
              />
            </FlexContainer>
            <Input
              data-testId={"Qc-associated-field-" + item.key}
              id="sushi-input"
              disabled={true}
              label={label}
              fullWidth
              value={value}
            />
          </form>
        );
      case "ev_doc":
        return (
          <form>
            <div>
              <p className="section-heading">Vehicle type</p>
              <RadioGroup
                options={getEvRadio(
                  getPath(initialState, item.valuePath, ""),
                  "Vehicle number required"
                )}
                horizontal
                selectedColor={variables.primaryColor}
                selected={
                  getPath(initialState, item.valuePath, "")[
                    "vehicle_number_required"
                  ]
                }
                className="sushi-radios"
                name={`ev_doc-vehicle_number_required-options`}
              />
            </div>
            <div>
              <p className="section-heading">Ownership type</p>
              <RadioGroup
                options={getEvRadio(
                  getPath(initialState, item.valuePath, ""),
                  "Ownership Type"
                )}
                horizontal
                selectedColor={variables.primaryColor}
                selected={
                  getPath(initialState, item.valuePath, "")["ownership_type"]
                }
                className="sushi-radios"
                name={`ev_doc-ownership_type-options`}
              />
            </div>
            <Input
              id="sushi-input"
              data-testId={"Qc-associated-field-" + item.key}
              disabled={true}
              label="Vehicle Number"
              fullWidth
              value={
                getPath(initialState, item.valuePath, "")["vehicle_number"]
              }
            />
            <Input
              id="sushi-input"
              data-testId={"Qc-associated-field-" + item.key}
              disabled={true}
              label="Vehicle Company"
              fullWidth
              value={
                getPath(initialState, item.valuePath, "")["vehicle_company"]
              }
            />
          </form>
        );
      default:
        return "";
    }
  };

  const getOptionalPhotoUrl = (activeImageItemKey) => {
    if (activeImageItemKey == "ev_doc") {
      if (onboardingFlow == "FASTRACK") {
        return getPath(
          details,
          QcDriverDocumentDetailFields["aadhar_card_doc"].valuePath,
          ""
        )["url"];
      } else {
        return getPath(
          details,
          QcDriverDocumentDetailFields["pan_card_doc"].valuePath,
          ""
        )["url"];
      }
    }
    return getPath(initialState, "basic_details.driver_photo.url", "");
  };

  const getOptionalPhotoTitle = (activeImageItemKey) => {
    if (activeImageItemKey == "ev_doc") {
      if (onboardingFlow == "FASTRACK") {
        return "Aadhar document";
      } else {
        return "PAN document";
      }
    }
    return "Driver Photo";
  };

  const getDocPhoto = (field) => {
    let url = getPath(
      details,
      QcDriverDocumentDetailFields[field].valuePath,
      ""
    )[QcDriverDocumentDetailFields[field].urlKey];
    return (
      url && (
        <DocImg onClick={() => handleDocClick(url, field)} src={url} alt="" />
      )
    );
  };

  const getAllSubmittedPhotos = (field) => {
    let docData = getPath(
      initialState,
      QcDriverDocumentDetailFields[field].valuePath,
      ""
    )["all_submitted_doc_urls"];
    return (
      <div>
        {docData != null && docData.length > 0 && (
          <div
            style={{
              float: "left",
              marginBottom: "10px",
            }}
          >
            <Divider height="5px" width="1000px" color={variables.grey} />
            <p
              className="section-heading"
              style={{
                textAlign: "left",
                padding: "25px",
                marginBottom: "10px",
                textDecoration: "underline",
              }}
            >
              All submitted documents
            </p>
            <DocImgContainer>
              {docData.map((doc, index) => {
                return <Slide key={index} docData={doc} />;
              })}
            </DocImgContainer>
          </div>
        )}
      </div>
    );
  };

  const getRejectionReasons = (key) => {
    if (getPath(Object.keys(rejectionReasons), "length", "")) {
      return rejectionReasons
        .filter((reason) => reason.key === key)
        .map((obj) => obj.reason);
    }
    return [];
  };

  const getDocTypes = (key) => {
    if (getPath(Object.keys(docTypes), "length", "")) {
      return docTypes.map((obj) => obj[key]);
    }
    return [];
  };

  const getEvModalLabel = () => {
    if (onboardingFlow == "FASTRACK") {
      return "Aadhar Name";
    } else {
      return "PAN Name";
    }
  };

  const getEvModalName = () => {
    if (onboardingFlow == "FASTRACK") {
      return getPath(
        details,
        QcDriverDocumentDetailFields["aadhar_card_doc"].valuePath,
        ""
      )["name"];
    } else {
      return getPath(
        details,
        QcDriverDocumentDetailFields["pan_card_doc"].valuePath,
        ""
      )["name"];
    }
  };
  const getModalValue = () => {
    if (activeImageItemKey) {
      if (activeImageItemKey === "address_doc") {
        return (
          getPath(details, "document_details.permanent_address.value", "") +
          "," +
          getPath(details, "document_details.permanent_address.zip_code", "")
        );
      } else if (activeImageItemKey === "ev_doc") {
        return true;
      }
      return getPath(
        details,
        QcDriverDocumentDetailFields[activeImageItemKey].valuePath,
        ""
      )[QcDriverDocumentDetailFields[activeImageItemKey].valueKey];
    }
    return false;
  };

  const shouldShowEdit = (field) => {
    if (field === "bank_doc") {
      return !getPath(
        initialState,
        "document_details." + field + ".third_party_verified",
        false
      );
    }
    return true;
  };

  const isEditable = (field) => {
    return getPath(
      initialState,
      "document_details." + field + ".editable",
      true
    );
  };

  const showField = (field) => {
    if (field === "bank_doc") {
      return getPath(initialState, "document_details.bank_doc.display", true);
    }
    return true;
  };

  const TickIcon = React.forwardRef(function TickIcon(props, ref) {
    //  Spread the props to the underlying DOM element.
    return (
      <div {...props} ref={ref} className="mr-10">
        <CheckCircleFill
          color={variables.primaryColor}
          className="cursor-pointer"
          onClick={() =>
            handleSaveSingleField(QcDriverDocumentDetailFields[props.field])
          }
        />
      </div>
    );
  });

  const CrossIcon = React.forwardRef(function CrossIcon(props, ref) {
    //  Spread the props to the underlying DOM element.
    return (
      <div {...props} ref={ref}>
        {" "}
        <CrossCircleFill
          onClick={() =>
            handleCrossClick(QcDriverDocumentDetailFields[props.field])
          }
          color={variables.primaryColor}
          className="cursor-pointer"
        />
      </div>
    );
  });

  const getVerifiedValue = (key) => {
    var localVerifiedOptions = JSON.parse(JSON.stringify(verifiedOptions));
    if (!isEditable(key)) {
      localVerifiedOptions[1]["disabled"] = true;
      localVerifiedOptions[0]["disabled"] = true;
    }
    return localVerifiedOptions;
  };

  return [
    <QcDriverDocumentDetailsEditContainer>
      {getPath(Object.keys(details), "length", 0) > 0 &&
        Object.keys(sortDocuments(details.document_details)).map(
          (field, index) => {
            return (
              QcDriverDocumentDetailFields[field] &&
              getRequiredFlag(QcDriverDocumentDetailFields[field]) &&
              showField(field) && (
                <FieldsSection key={field + index}>
                  <p className="section-heading">
                    {QcDriverDocumentDetailFields[field].heading.toUpperCase()}
                  </p>
                  <BorderedBox className="fields-holder mb-40">
                    <FlexContainer align="flex-start">
                      <QcDocumentFieldsContainer>
                        <FlexContainer align="flex-start">
                          <div
                            className={`w-full ${
                              !QcDriverDocumentDetailFields[field][
                                "noRightMargin"
                              ] && "mr-10"
                            }`}
                          >
                            {getField(QcDriverDocumentDetailFields[field])}
                          </div>
                          {QcDriverDocumentDetailFields[field].isEditable &&
                            isEditable(field) &&
                            !qcApproved &&
                            allMenuActions[permission] &&
                            shouldShowEdit(field) &&
                            (editableField === field &&
                            showSingleFieldEditOptions === field ? (
                              <FlexContainer justify="flex-start">
                                <Tooltip title="Save" arrow placement="top">
                                  <TickIcon field={field} />
                                </Tooltip>
                                <Tooltip title="Cancel" arrow placement="top">
                                  <CrossIcon field={field} />
                                </Tooltip>
                              </FlexContainer>
                            ) : (
                              !showSingleFieldEditOptions && (
                                <AddEdit
                                  className="cursor-pointer"
                                  onClick={() =>
                                    handleEditSingleField(
                                      QcDriverDocumentDetailFields[field]
                                    )
                                  }
                                  color={variables.primaryColor}
                                />
                              )
                            ))}
                        </FlexContainer>
                        {QcDriverDocumentDetailFields[field][
                          "additionalAssociatedField"
                        ] &&
                          getAdditionalFields(
                            QcDriverDocumentDetailFields[field]
                          )}
                        {QcDriverDocumentDetailFields[field]
                          .hasSecondaryField &&
                          getSecondaryField(
                            QcDriverDocumentDetailFields[field]
                          )}
                        {getDocPhoto(field)}
                        <div>{getAllSubmittedPhotos(field)}</div>
                        {!QcDriverDocumentDetailFields[field][
                          "skipRadioAcceptRejectField"
                        ] && (
                          <RadioGroup
                            options={getVerifiedValue(field)}
                            horizontal
                            selectedColor={variables.primaryColor}
                            selected={
                              getPath(
                                initialState,
                                QcDriverDocumentDetailFields[field].valuePath,
                                ""
                              )["verified"]
                            }
                            className="sushi-radios"
                            onChange={(e) =>
                              handleVerifiedChange(
                                QcDriverDocumentDetailFields[field],
                                e,
                                "document_details"
                              )
                            }
                            name={`${field}-verified-options`}
                          />
                        )}
                        {!QcDriverDocumentDetailFields[field][
                          "skipRejectionReasonsField"
                        ] && (
                          <CheckBoxDropDown
                            options={getRejectionReasons(field)}
                            value={
                              getPath(
                                initialState,
                                QcDriverDocumentDetailFields[field].valuePath,
                                ""
                              ).rejection_reason
                            }
                            handleChange={handleRejectionReasonChange}
                            placeholder="Select rejection reason"
                            keyToChange={field}
                            extraParams={[
                              QcDriverDocumentDetailFields[field],
                              "document_details",
                            ]}
                            showCross={true}
                            labelWidth="30%"
                            id={`driverQcDocumentDetailsDropdown${field}`}
                            disabled={
                              qcApproved ||
                              getPath(
                                initialState,
                                `document_details.${field}.verified`,
                                false
                              )
                            }
                          />
                        )}
                        {QcDriverDocumentDetailFields[field][
                          "docTypeAssociatedField"
                        ] &&
                          getDropDownForType(
                            QcDriverDocumentDetailFields[field]
                          )}
                      </QcDocumentFieldsContainer>
                      {(field === "pan_card_doc" || field == "bank_doc") &&
                        getPath(
                          details,
                          QcDriverDocumentDetailFields[field].valuePath,
                          ""
                        )["third_party_verified"] && (
                          <Pill>{"NSDL Verified"}</Pill>
                        )}
                    </FlexContainer>
                  </BorderedBox>
                </FieldsSection>
              )
            );
          }
        )}
    </QcDriverDocumentDetailsEditContainer>,
    <DriverDocumentModal
      fullWidthModal={activeImageItemKey != "aadhar_card_doc"}
      optionalPhotoTitle={getOptionalPhotoTitle(activeImageItemKey)}
      optionalPhotoUrl={getOptionalPhotoUrl(activeImageItemKey)}
      showModal={showModal}
      optionalInput={
        Object.keys(activeImageItemKey).length > 0 &&
        getModalValue() && (
          <>
            {!["bank_doc", "ev_doc"].includes(activeImageItemKey) && (
              <Input
                id="sushi-input"
                data-testId="modalInputVal"
                disabled={true}
                label={capitalizeFirstLetter(
                  activeImageItemKey.split("_").join(" ") + " value"
                )}
                value={getModalValue()}
              />
            )}
            {activeImageItemKey == "ev_doc" && (
              <Input
                id="sushi-input"
                data-testId="modalInputVal"
                disabled={true}
                label={getEvModalLabel()}
                value={getEvModalName()}
              />
            )}
            {QcDriverDocumentDetailFields[activeImageItemKey][
              "additionalAssociatedField"
            ] &&
              getAdditionalFields(
                QcDriverDocumentDetailFields[activeImageItemKey]
              )}
          </>
        )
      }
      handleClose={handleClose}
      modalContent={modalContent}
    />,
    <Toast
      show={toast}
      align="top"
      onClose={closeToast}
      text={toastMessage}
      type="error"
      autoHideDuration={2}
    />,
  ];
};

const QcDriverDocumentDetailsEditContainer = styled(BorderedBox)`
  margin-top: 20px;
  width: 100%;
`;

const QcDocumentFieldsContainer = styled.div`
  flex: ${isMobile() ? " 0 1 100%" : " 0 1 60%"};
  display: flex;
  flex-direction: column;
`;

function mapStateToProps(state) {
  const { QcDetails, MenuActions, State } = state;
  return {
    currentActiveFeId: QcDetails.currentActiveFeId,
    allMenuActions: MenuActions.allMenuActions,
    nextPageState: State.nextPage,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    updateQcField: bindActionCreators(updateQcField, dispatch),
    setQcDetails: bindActionCreators(setQcDetails, dispatch),
    getStateList: bindActionCreators(getStateList, dispatch),
    getState: bindActionCreators(getState, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(QcDriverDocumentDetailsEdit);
